import Icon from "../../Icon/Icon";
import styles from "./AllSitesPill.module.css";
import SiteNav from "./SiteNav";

type Props = {
  variant: "row" | "pill";
  onSelectAll: () => void;
  disabled?: boolean;
};

function AllSitesPill({ variant, onSelectAll, disabled = false }: Props) {
  const handleClick = () => {
    onSelectAll();
  };

  return (
    <SiteNav
      to="/"
      onClick={handleClick}
      preventNavigation
      disabled={disabled}
      className={
        variant === "pill"
          ? `${styles.allSitesPill} ${disabled ? styles.disabled : ""}`
          : `${styles.allSitesRow} ${disabled ? styles.disabled : ""}`
      }
    >
      <span className={styles.siteIcon}>
        <Icon name="Globe" className={styles.globeIcon} />
      </span>
      <span className={styles.siteName}>All sites</span>
    </SiteNav>
  );
}

export default AllSitesPill;
